<template>
  <div>
    <Widget>
      <div
        v-if="data_laporan?.status_laporan === 'Komentar/Informasi terhadap Penyampaian Laporan Tahunan'"
        class="card bg-warning mb-4"
      >
        <div class="card-body p-0">
          <h4 class="card-title m-3">Catatan Penolakan</h4>
          <div class="m-3">
            <div v-html="data_laporan.catatan_laporan_tahunan"></div>
          </div>
        </div>
      </div>

      <form-wizard
        shape="tab"
        color="#3498db"
        title=""
        subtitle=""
        @on-change="updateProgress"
        @on-loading="updateProgress(1, 1)"
      >
        <b-progress class="progress-xs" variant="info" :value="progress" :max="4" />
        <b-button slot="prev" id="prev-form" variant="primary" class="text-white" hidden>
          <i class="fa fa-caret-left" /> Previews
        </b-button>
        <b-button slot="next" id="next-form" variant="primary" class="text-white" hidden>
          Selanjutnya <i class="fa fa-caret-right" />
        </b-button>
        <b-button slot="finish" id="finish-form" variant="success" class="text-white" hidden>
          Selesai <i class="fa fa-check" />
        </b-button>

        <tab-content title="Identitas">
          <formIdentitas v-if="progress === 1" ref="form1" />
        </tab-content>

        <tab-content title="Kemajuan Perizinan">
          <formKemajuanPerizinan v-if="progress === 2" ref="form2" />
        </tab-content>

        <tab-content title="Realisasi Pemanfaatan Ruang Laut">
          <formRealisasiPemanfaatanRuangLaut v-if="progress === 3" ref="form3" />
        </tab-content>

        <tab-content title="Pemenuhan Kewajiban">
          <formPemenuhanKewajiban v-if="progress === 4" ref="form4" />
        </tab-content>

        <div class="d-flex justify-content-between" style="padding: 14px 20px 14px 20px">
          <b-button @click="btnBack" id="btn_back" v-if="progress === 1" variant="danger" style="color: white">
            Kembali
          </b-button>
          <b-button id="btn_previews" v-else @click="prevForm" variant="primary">
            <i class="fa fa-caret-left" /> Tab Sebelumnya
          </b-button>

          <b-button id="btn_next" @click="nextForm" variant="primary" style="float: right" :hidden="!(progress !== 4)">
            Tab Selanjutnya <i class="fa fa-caret-right" />
          </b-button>
          <div id="btn_finish" style="float: right" :hidden="progress !== 4 || page_pemenuhan !== 16">
            <template v-if="!is_selesai">
              <b-button @click="nextForm()" variant="secondary"> Simpan Draf <i class="fa fa-check" /> </b-button>
              <b-button @click="nextForm('Laporan telah disubmit')" variant="success" class="ms-2">
                Submit <i class="fa fa-check" />
              </b-button>
            </template>
            <template v-else>
              <b-button @click="$router.push('/app/laporan-tahunan')" variant="secondary"> Kembali </b-button>
            </template>
          </div>
        </div>
      </form-wizard>
    </Widget>
  </div>
</template>

<style scoped>
:deep(.wizard-nav li) {
  pointer-events: none;
}

:deep(.input-units) {
  position: relative;
  overflow: hidden;
}

:deep(.input-units .text-units) {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 0px;
  margin: 0.375rem 1rem;
  border: 1px solid rgba(0, 0, 0, 0);
}

:deep(.input-units .text-units span:first-child) {
  visibility: hidden;
}

:deep(.wizard-header) {
  display: none;
}
</style>

<script>
import Vue from 'vue'
import Widget from '@/components/Widget/Widget'
import formIdentitas from './formIdentitas.vue'
import formKemajuanPerizinan from './formKemajuanPerizinan.vue'
import formRealisasiPemanfaatanRuangLaut from './formRealisasiPemanfaatanRuangLaut.vue'
import formPemenuhanKewajiban from './formPemenuhanKewajiban.vue'
import { Validator } from 'vee-validate'
import Swal from 'sweetalert2'
import axios from 'axios'
import dayjs from 'dayjs'

export default {
  components: {
    Widget,
    formIdentitas,
    formKemajuanPerizinan,
    formRealisasiPemanfaatanRuangLaut,
    formPemenuhanKewajiban,
  },
  data() {
    return {
      progress: 1,
      id_laporan_perizinan_berusaha: [],
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      is_selesai: false,
      data_laporan: null,
      page_pemenuhan: 1,
    }
  },
  provide() {
    return {
      inj_is_selesai: () => this.is_selesai,
      setIsSelesai: (val) => {
        this.is_selesai = val
      },
      inj_data_laporan: () => this.data_laporan,
      setDataLaporan: (val) => {
        this.data_laporan = val
      },
      inj_page_pemenuhan: () => this.page_pemenuhan,
      setPagePemenuhan: (val) => {
        this.page_pemenuhan = val
      },
    }
  },
  mounted() {
    const dictionary = {
      id: {
        messages: {
          required: (fieldName) => `${fieldName} wajib diisi`,
          email: () => 'Email tidak valid',
        },
      },
    }
    Validator.localize(dictionary)
    this.$validator.localize('id')
  },
  methods: {
    updateProgress(prevIndex, nextIndex) {
      if (nextIndex >= 0) {
        Vue.set(this, 'progress', nextIndex + 1)
      }
    },

    prevForm() {
      document.getElementById('prev-form').click()
      setTimeout(() => {
        $('html,body').scrollTop(0)
      }, 100)
    },

    async nextForm(status = '') {
      if (this.progress === 1) {
        if (await this.$refs.form1.nextForm()) {
          document.getElementById('next-form').click()
        }
      } else if (this.progress === 2) {
        if (await this.$refs.form2.nextForm()) {
          document.getElementById('next-form').click()
        }
      } else if (this.progress === 3) {
        if (await this.$refs.form3.nextForm()) {
          document.getElementById('next-form').click()
        }
      } else if (this.progress === 4) {
        if (await this.$refs.form4.nextForm()) {
          if (!status) {
            this.$router.push('/app/laporan-tahunan')
          } else {
            if (await this.submitLaporanTahunan(status)) {
              this.$router.push('/app/laporan-tahunan')
            }
          }
        }
      }
      setTimeout(() => {
        $('html,body').scrollTop(0)
      }, 500)
    },

    async submitLaporanTahunan(status) {
      const { value: accept } = await Swal.fire({
        title: 'Pakta Integritas',
        input: 'checkbox',
        text: 'Menyatakan bahwa laporan tahunan pemegang KKPRL yang kami sampaikan adalah benar sesuai dengan ketentuan yang berlaku.',
        inputPlaceholder: 'Laporan yang sudah disubmit tidak dapat diedit kembali',
        confirmButtonText: 'Setuju',
        inputValidator: (result) => {
          return !result && 'Pakta integritas wajib disetujui'
        },
      })
      if (!accept) return false

      const formData = {
        status_laporan: status, 
      }
      if (this.data_laporan.status_laporan !== 'Komentar/Informasi terhadap Penyampaian Laporan Tahunan') {
        formData.tanggal_submit_laporan = dayjs(new Date()).format('YYYY-MM-DD')
      }

      return await axios
        .post(
          this.baseapiPengendalian + `api/laporan_tahunan/${this.$route.query.id_laporan}`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ` + this.user.accessToken,
            },
          },
        )
        .then((res) => {
          Swal.fire('Berhasil', 'Berhasil submit laporan tahunan', 'success')
          return true
        })
        .catch((err) => {
          Swal.fire('Gagal', 'Gagal submit laporan tahunan', 'error')
          return false
        })
    },

    btnBack() {
      this.$router.push('/app/laporan-tahunan')
    },
  },
}
</script>
